import { type IUserEngagementEvent, EventType, publishEvent } from "@/events";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function debounce<F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  wait: number
): (...args: Parameters<F>) => void {
  let timeoutId: NodeJS.Timeout | null = null;

  return function(this: unknown, ...args: Parameters<F>): void {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      func.apply(this, args);
      timeoutId = null;
    }, wait);
  };
}

export const fireUserEngagementEvent = () => {
  const event: IUserEngagementEvent = {
    type: EventType.USER_ENGAGEMENT,
  };
  publishEvent(event);
}

/**
 * Converts a paisa amount to rupees with two decimal precision.
 * @param paisa - The amount in paisa (e.g., 1299)
 * @returns The amount in rupees as a number (e.g., 12.99)
 */
export const convertPaisaToRupees = (paisa: number): number => {
  return +(paisa / 100).toFixed(2);
}

// Helper function to strip HTML tags from text
export const stripHtml = (html: string): string => {
  if (!html) return '';
  return html.replace(/<[^>]*>?/gm, '').trim();
}

